// WASM readiness flag + constructor registry — DELIBERATELY GLUE-FREE.
//
// WHY THIS MODULE EXISTS
//
// Everything in this file used to live in wasm-loader.ts, which statically
// imports the wasm-bindgen glue (`../pkg/layers_core.js`). core.ts needed two
// things from that module — `isWasmReady()` and the `WasmLayersCore` class as a
// runtime value — so importing core.ts pulled the glue into every bundle, on
// every platform.
//
// On Metro (React Native / Expo) that is fatal, not merely wasteful. tsdown
// bundles the glue into dist/, and its CJS form contains wasm-pack's
// Node-oriented binary locator:
//
//   module_or_path = new URL("layers_core_bg.wasm",
//                            require("url").pathToFileURL(__filename).href);
//
// Metro cannot resolve Node's `url`, so every RN/Expo app failed to bundle with
// "attempted to import the Node standard library module 'url'". That was true
// of every published version since 1.4.6 — the RN SDK was never installable.
//
// Splitting the *state* away from the *loader* lets core.ts (and therefore the
// react-native entry) depend on WASM readiness without naming the glue. The
// loader still owns loading; it just publishes its result here.
//
// Note the type-only import below: `import type` is erased at build time, so it
// creates no module edge in the emitted JS. That is the only form of reference
// to `../pkg/` permitted anywhere in the react-native module graph.
import type { WasmLayersCore } from '../pkg/layers_core.js';

/** Constructor shape of the wasm-bindgen `WasmLayersCore` class. */
export type WasmLayersCoreCtor = new (config: unknown) => WasmLayersCore;

let _wasmReady = false;
let _wasmCtor: WasmLayersCoreCtor | null = null;

/** Check if WASM has been successfully initialized. */
export function isWasmReady(): boolean {
  return _wasmReady;
}

/**
 * Mark WASM as initialized. Called by wasm-loader.ts after a successful
 * `init()` / `initSync()`; never call it without also registering the
 * constructor, or LayersCore will believe WASM is live with nothing to build.
 * @internal
 */
export function markWasmReady(): void {
  _wasmReady = true;
}

/**
 * Publish the `WasmLayersCore` class for core.ts to construct.
 *
 * This is the value that used to be a static import in core.ts. Registering it
 * at load time (rather than importing it) mirrors the `registerEnsureWasm()`
 * hook idiom already used for the Node sync loader: the entry point decides
 * what gets pulled in, and core.ts stays free of platform-specific modules.
 * @internal
 */
export function registerWasmCtor(ctor: WasmLayersCoreCtor): void {
  _wasmCtor = ctor;
}

/**
 * The registered `WasmLayersCore` class, or null when no loader has run
 * (the React Native entry never registers one).
 * @internal
 */
export function getWasmCtor(): WasmLayersCoreCtor | null {
  return _wasmCtor;
}
